
// import customLeftNavSettings from "@/apps/custom-left-nav/app.config"


var generateConfig = (appSettings) => {
    var result = {
        name : appSettings.name,
        route : appSettings.parentRoute,
        icon: appSettings.icon,
        description : appSettings.description,
        color : appSettings.accentColor,
        children : appSettings.navigation.map(nav => {
            return {
                name : nav.title,
                route : `${appSettings.parentRoute}/${nav.route}`,
                icon: nav.icon,
            }
        })
    };
    // console.log(result);
    return result;
};
const apps = [
    // customLeftNavSettings,
].map(app => generateConfig(app));

// console.log(apps);
// debugger;

export default apps


// {
//     name : "Tutorials",
//     route : "/tutorials",
//     icon:"mdi-school",
//     description : "Your home page",
//     color : 'blue darken-2'
// },

